import { LinearProgress, Typography, makeStyles } from '@material-ui/core';
import { COLORS } from '../../theme/variables';

const useStyles = makeStyles((theme) => ({
  stepHeader: {
    marginBottom: 32,
  },
  stepHeaderTitle: {
    marginBottom: 12,
  },
  progressBar: {
    height: 8,
    borderRadius: 4,
    backgroundColor: COLORS.COLOR_GRAY_LIGHTENED_30,
    '& .MuiLinearProgress-bar': {
      borderRadius: 4,
      backgroundColor: COLORS.COLOR_BLUE_BASE,
    },
  },
  progressLabel: {
    marginBottom: 8,
    color: COLORS.COLOR_TEXT_LIGHTENED_20,
    fontSize: 14,
  },
}));

interface StepHeaderProps {
  title: string;
  stepNumber: number;
  totalSteps: number;
  percentage?: number;
}

const StepHeader = ({
  title,
  stepNumber,
  totalSteps,
  percentage,
}: StepHeaderProps) => {
  const classes = useStyles();

  // Default calculation if percentage is not provided
  const progressValue = percentage !== undefined
    ? percentage
    : (stepNumber / totalSteps) * 100;

  // Ensure value is between 0 and 100
  const normalizedProgressProps = Math.min(100, Math.max(0, progressValue));

  return (
    <div className={classes.stepHeader}>
      <Typography variant='h3' className={classes.stepHeaderTitle}>
        {title}
      </Typography>
      <div className={classes.progressLabel}>
        Step {stepNumber} of {totalSteps}
      </div>
      <LinearProgress
        variant='determinate'
        value={normalizedProgressProps}
        className={classes.progressBar}
      />
    </div>
  );
};

export default StepHeader;
